function quantityMultiplier() {
    const t = document.getElementById("quantity").value;
    const e = undefined;
    const n = document.getElementsByClassName("product-form")[0]["properties[_boldVariantQtys]"];

    if (void 0 === n)
        return;
    let o = n.value;

    if ("" !== o && t > 1) {
        const t = o.replace(/\*/g, "");
        n.value = t
    }
}

document.addEventListener("DOMContentLoaded", (function() {
  if (BOLD && BOLD.options && BOLD.options.app) {
    BOLD.options.app.on("adding_to_cart", (() => quantityMultiplier()))
  }
}));